import { Box, Divider, Grid2, Stack, Typography } from "@mui/material";

import { Puller } from "./components";

export const PageTitle = ({
  pageTitle,
  actions,
}: {
  pageTitle: string | JSX.Element;
  // Page-level controls, rendered opposite the title.
  actions?: React.ReactNode;
}) => {
  return (
    <Grid2 container direction={"column"} spacing={3}>
      <Puller />
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{ pt: 2 }}
      >
        {typeof pageTitle === "string" ? (
          <Typography
            variant="h4"
            component="div"
            color="primary"
            fontSize={28}
            lineHeight={0.9}
            fontWeight={900}
          >
            {pageTitle}
          </Typography>
        ) : (
          // A page's own title element lays itself out; give it the whole row
          // so its parts can spread apart instead of piling up at the left.
          <Box sx={{ flex: 1, minWidth: 0 }}>{pageTitle}</Box>
        )}
        {actions && (
          // Negative margins pull an icon button's own padding back out of the
          // layout, so the glyph centres on the title and sits flush with the
          // content edge while keeping its full touch target.
          <Box sx={{ display: "flex", alignItems: "center", my: -1, mr: -1 }}>
            {actions}
          </Box>
        )}
      </Stack>
      <Divider sx={{ my: 1 }} />
    </Grid2>
  );
};
